<alaris-dialog [closeAction]="close.bind(this)" [confirmAction]="confirm.bind(this)" [loading$]="rolesService.loading$"
			   size="md">
	<h6 slot="header">{{ 'users_roles.roles.roleRemoving' | translate }}</h6>
	<div slot="content">
		<h3><strong>{{ data.role.Name }}</strong></h3>
	</div>
</alaris-dialog>
